import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitofivejyotilingacab() {



  const cardData =
  {
    keyword: 'Mumbai to 5 Jyotirlinga Cab ',
    heading: 'Shambhu Cabs: Mumbai to 5 Jyotirlinga Cab  ',
    headingDescription: 'Shambhu Cabs offers dependable Mumbai to 5 Jyotirlinga Cab services, ensuring a safe, comfortable, and spiritually enriching journey for devotees visiting the sacred Jyotirlingas of Maharashtra. Our well-maintained fleet of hatchbacks, sedans, SUVs, and tempo travellers is ideal for families, groups, and senior citizens seeking a smooth pilgrimage experience. With experienced chauffeurs familiar with the 5 Jyotirlinga route—Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath—we provide flexible 3-day, 4-day, and custom packages as per your convenience. Shambhu Cabs offers doorstep pickup from South Mumbai to Thane, Andheri to Navi Mumbai, along with 24/7 booking support for a seamless pilgrimage. Whether it’s a family yatra or a group spiritual tour, Shambhu Cabs ensures a peaceful, safe, and well-organized Mumbai to 5 Jyotirlinga travel experience.',

    top: 'Top Places to Visit in 5 Jyotirlinga with Shambhu Cabs',

 "topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga, Nashik",
    "description": "Trimbakeshwar Temple, located in the Brahmagiri hills near Nashik, is one of the 12 Jyotirlingas of Lord Shiva. The unique three-faced lingam represents Brahma, Vishnu, and Mahesh. The temple is also the source of the sacred Godavari River and attracts thousands of devotees annually."
  },
  {
    "title": "Grishneshwar Jyotirlinga, Ellora",
    "description": "Grishneshwar Temple, near the Ellora Caves in Aurangabad district, is an ancient shrine dedicated to Lord Shiva. The temple features beautiful Hemadpanthi architecture and is revered for its spiritual energy, drawing devotees from across Maharashtra and India."
  },
  {
    "title": "Bhimaneshwar Jyotirlinga, Bhimashankar",
    "description": "Bhimashankar Temple, located in the dense Sahyadri forest of Pune district, is a Jyotirlinga shrine dedicated to Lord Shiva. The temple is surrounded by lush greenery and the Bhimashankar Wildlife Sanctuary. It is an important pilgrimage site and trekking destination."
  },
  {
    "title": "Vishweshwar Jyotirlinga, Ambajogai / Kolhapur Region",
    "description": "Vishweshwar Jyotirlinga, also known as Aundha Nagnath in Hingoli, is an ancient temple dedicated to Lord Shiva. The temple is a remarkable example of Hemadpanthi architecture and hosts grand festivals like Mahashivratri, attracting devotees from all over the region."
  },
  {
    "title": "Mallikarjuna Jyotirlinga, Shringeri / Maharashtra",
    "description": "Though the main Mallikarjuna Jyotirlinga is in Andhra Pradesh, Maharashtra devotees often include it in pilgrimages as part of the Jyotirlinga Yatra. Maharashtra has other prominent Shiva temples closely associated with Jyotirlinga legends, emphasizing the state’s rich Shaivite heritage."
  }
],


"services": [
  {
    "name": "5 Jyotirlinga Darshan Cab Mumbai",
    "description": "5 Jyotirlinga Darshan Cab Mumbai offers reliable and comfortable travel for pilgrims visiting the five Jyotirlinga temples from Mumbai. This service includes professional drivers familiar with temple routes, well-maintained vehicles, flexible pickups, and round-trip options. Passengers can enjoy a safe, stress-free journey while exploring spiritual landmarks, making it ideal for families, solo travelers, and groups seeking a memorable pilgrimage experience."
  },
  {
    "name": "Mumbai Jyotirlinga Tour Taxi",
    "description": "Mumbai Jyotirlinga Tour Taxi provides a comprehensive cab service for travelers planning a multi-day tour of the five Jyotirlinga temples. Vehicles are equipped with modern amenities and spacious seating. Professional chauffeurs ensure smooth navigation across highways and rural routes. This service allows pilgrims to focus on the spiritual journey while enjoying comfort, timely pickups, and convenient drop-offs at each temple."
  },
  {
    "name": "Jyotirlinga Yatra Cab Mumbai",
    "description": "Jyotirlinga Yatra Cab Mumbai is designed for devotees undertaking the complete Jyotirlinga pilgrimage from Mumbai. With well-planned itineraries, comfortable vehicles, and experienced drivers, the service ensures hassle-free travel. Passengers can enjoy scenic routes, safe rides, and the flexibility to adjust travel plans while covering all five sacred temples efficiently and comfortably."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Package Cab",
    "description": "Mumbai to 5 Jyotirlinga Package Cab offers a customized travel package for visiting all five Jyotirlinga temples. The service includes professional drivers, well-maintained cars, flexible schedules, and guided route planning. Ideal for families, corporate groups, or spiritual travelers, this package ensures a smooth, stress-free, and memorable pilgrimage experience from start to finish."
  },
  {
    "name": "Affordable Jyotirlinga Cab Mumbai",
    "description": "Affordable Jyotirlinga Cab Mumbai provides budget-friendly travel options for pilgrims without compromising comfort or safety. Vehicles are maintained to high standards, drivers are experienced, and the service includes timely pickups and drop-offs. Perfect for students, families, or solo travelers, this service ensures an economical yet reliable way to complete the Jyotirlinga yatra."
  },
  {
    "name": "Best Jyotirlinga Darshan Taxi Mumbai",
    "description": "Best Jyotirlinga Darshan Taxi Mumbai is known for its punctuality, well-maintained vehicles, and professional drivers. Catering to families, groups, and solo travelers, the service prioritizes comfort, safety, and convenience. Passengers can enjoy a seamless journey covering all five Jyotirlinga temples with minimal stress and maximum spiritual satisfaction."
  },
  {
    "name": "One-Way Jyotirlinga Cab",
    "description": "One-Way Jyotirlinga Cab is ideal for passengers seeking a single-direction trip to the Jyotirlinga temples. Perfect for business travelers, solo pilgrims, or those relocating, this service ensures an economical and convenient travel option with professional drivers, comfortable vehicles, and hassle-free pickup and drop arrangements."
  },
  {
    "name": "5 Jyotirlinga Car Rental Mumbai",
    "description": "5 Jyotirlinga Car Rental Mumbai provides flexible and reliable car hire options for travelers heading on a Jyotirlinga pilgrimage. Customers can choose from sedans, SUVs, or premium vehicles with experienced chauffeurs. This service allows complete control over the travel schedule, ensuring safety, comfort, and timely arrivals at all temples during the journey."
  },
  {
    "name": "SUV Cab Jyotirlinga Tour",
    "description": "SUV Cab Jyotirlinga Tour caters to larger groups or families requiring spacious and comfortable vehicles for the Jyotirlinga pilgrimage. Equipped with modern amenities and safety features, these SUVs ensure a smooth ride across highways and rural roads. Professional drivers guide the trip, letting passengers focus entirely on the spiritual experience."
  },
  {
    "name": "Sedan Cab Jyotirlinga Trip",
    "description": "Sedan Cab Jyotirlinga Trip offers an economical and comfortable option for solo travelers or small families visiting the Jyotirlinga temples. Well-maintained sedans with professional chauffeurs ensure timely arrivals and safe, smooth travel. This service allows passengers to enjoy scenic routes and a relaxed journey throughout the pilgrimage."
  },
  {
    "name": "Mumbai Jyotirlinga Pilgrimage Cab",
    "description": "Mumbai Jyotirlinga Pilgrimage Cab provides a complete travel solution for devotees visiting all five Jyotirlinga temples. With professional drivers, comfortable vehicles, route planning, and flexible scheduling, this service ensures an organized, stress-free, and spiritually fulfilling journey for families, groups, and solo travelers."
  },
  {
    "name": "24×7 Jyotirlinga Taxi Mumbai",
    "description": "24×7 Jyotirlinga Taxi Mumbai offers round-the-clock cab service for pilgrims traveling from Mumbai to the Jyotirlinga temples. Early morning departures or late-night returns are accommodated with professional drivers, safe vehicles, and flexible scheduling. Passengers benefit from convenient, reliable, and timely transport for a hassle-free pilgrimage experience."
  },
  {
    "name": "Family Cab for 5 Jyotirlinga Darshan",
    "description": "Family Cab for 5 Jyotirlinga Darshan is designed for family groups seeking a comfortable, safe, and organized pilgrimage experience. Spacious vehicles, professional chauffeurs, and flexible schedules ensure that families can travel together efficiently while enjoying the journey. This service focuses on convenience, safety, and a stress-free travel environment."
  },
  {
    "name": "Corporate Jyotirlinga Cab Mumbai",
    "description": "Corporate Jyotirlinga Cab Mumbai offers specialized services for corporate groups or office teams planning a Jyotirlinga pilgrimage. With professional drivers, comfortable vehicles, and planned routes, the service ensures smooth and efficient group travel. This option is perfect for team retreats, spiritual tours, or corporate wellness trips."
  },
  {
    "name": "Long Trip Cab Mumbai Jyotirlinga",
    "description": "Long Trip Cab Mumbai Jyotirlinga is perfect for devotees undertaking extended travel to cover all five Jyotirlinga temples. The service includes professional drivers, comfortable vehicles, highway-optimized routes, and flexible schedules. Passengers can enjoy a safe, relaxed, and well-organized pilgrimage experience across multiple days."
  },
  {
    "name": "Safe Jyotirlinga Darshan Cab",
    "description": "Safe Jyotirlinga Darshan Cab emphasizes passenger safety during travel from Mumbai to the Jyotirlinga temples. Well-maintained vehicles, experienced drivers, and adherence to traffic and safety regulations ensure a secure journey. This service is ideal for families, solo travelers, and groups seeking a reliable and comfortable pilgrimage experience."
  },
  {
    "name": "Premium Jyotirlinga Tour Cab",
    "description": "Premium Jyotirlinga Tour Cab provides a luxurious travel experience for pilgrims visiting the Jyotirlinga temples. High-end vehicles, professional chauffeurs, and personalized services ensure comfort, safety, and a stress-free journey. This option is perfect for travelers seeking a premium, organized, and memorable spiritual trip from Mumbai."
  }
],

"tableData": [
  ["5 Jyotirlinga Darshan Cab Mumbai", "Mumbai Jyotirlinga Tour Taxi"],
  ["Jyotirlinga Yatra Cab Mumbai", "Mumbai to 5 Jyotirlinga Package Cab"],
  ["Affordable Jyotirlinga Cab Mumbai", "Best Jyotirlinga Darshan Taxi Mumbai"],
  ["One-Way Jyotirlinga Cab", "5 Jyotirlinga Car Rental Mumbai"],
  ["SUV Cab Jyotirlinga Tour", "Sedan Cab Jyotirlinga Trip"],
  ["Mumbai Jyotirlinga Pilgrimage Cab", "24×7 Jyotirlinga Taxi Mumbai"],
  ["Family Cab for 5 Jyotirlinga Darshan", "Corporate Jyotirlinga Cab Mumbai"],
  ["Long Trip Cab Mumbai Jyotirlinga", "Safe Jyotirlinga Darshan Cab"],
  ["Premium Jyotirlinga Tour Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to 5 Jyotirlinga Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers dependable Mumbai to 5 Jyotirlinga cab services, perfect for spiritual journeys, pilgrimage trips, and comfortable long-distance travel across the sacred sites."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs for a smooth and relaxing journey to all 5 Jyotirlinga temples."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pilgrimage Routes",
    "WhyChoosedescription": "Our professional drivers are well-versed with the Mumbai to 5 Jyotirlinga routes, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to 5 Jyotirlinga cab journey stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, travel queries, and route guidance for your pilgrimage."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Pilgrimage Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans designed to fit your Mumbai to 5 Jyotirlinga travel itinerary."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip, ensuring a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making your Mumbai to 5 Jyotirlinga journey smooth, comfortable, and worry-free."
  }
]




















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to 5 Jyotirlinga cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to 5 Jyotirlinga cab services for devotees planning a pilgrimage.',
  },
  {
    question: 'How can I book a Mumbai to 5 Jyotirlinga cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to 5 Jyotirlinga cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars suitable for long-distance pilgrimage travel to all five Jyotirlinga temples.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to 5 Jyotirlinga route?',
    answer: 'Yes, our drivers are licensed, professional, and experienced in covering the 5 Jyotirlinga pilgrimage route safely and comfortably.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to 5 Jyotirlinga trip?',
    answer: 'Absolutely. You can select your preferred pickup point in Mumbai and drop-off locations at any of the five Jyotirlinga temples.',
  },
  {
    question: 'Is the Mumbai to 5 Jyotirlinga cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to 5 Jyotirlinga cab services to suit your pilgrimage schedule.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to 5 Jyotirlinga cab bookings?',
    answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety and hygiene protocols for passenger well-being.',
  },
  {
    question: 'What payment options are available for Mumbai to 5 Jyotirlinga cab bookings?',
    answer: 'We accept payments via UPI, digital wallets, credit/debit cards, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the Mumbai to 5 Jyotirlinga journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Mumbai to 5 Jyotirlinga travel for any assistance.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Manoj Kulkarni',
    feedback: 'Our Mumbai to 5 Jyotirlinga pilgrimage with Shambhu Cabs was comfortable and well-organized. The driver was punctual and helpful.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shweta Deshmukh',
    feedback: 'Highly reliable Mumbai to 5 Jyotirlinga cab service. Smooth journey and excellent support from Shambhu Cabs throughout our trip.',
    rating: 5,
  },
];












































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to 5 Jyotirlinga Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-5-jyotirlinga-cab.jpg",
  "description": "Shambhu Cabs offers safe and reliable Mumbai to 5 Jyotirlinga cab services for pilgrims, families, and corporate travelers. Book one-way or round-trip taxis with sedan, SUV, or premium cars for comfortable travel. Perfect for 5 Jyotirlinga Darshan, Jyotirlinga Yatra, and long trips with professional drivers and affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-5-jyotirlinga-cab"
  }
};




  return (
    <div>
<Helmet>
  <title>Mumbai to 5 Jyotirlinga Cab | Safe Pilgrimage Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to 5 Jyotirlinga cab with Shambhu Cabs. Safe, affordable, and comfortable travel for 5 Jyotirlinga Darshan, Jyotirlinga Yatra, and long trips. Choose sedan, SUV, or premium cars with professional drivers."
  />

  <meta
    name="keywords"
    content="5 Jyotirlinga Darshan Cab Mumbai, Mumbai Jyotirlinga Tour Taxi, Jyotirlinga Yatra Cab Mumbai, Mumbai to 5 Jyotirlinga Package Cab, Affordable Jyotirlinga Cab Mumbai, Best Jyotirlinga Darshan Taxi Mumbai, One-Way Jyotirlinga Cab, 5 Jyotirlinga Car Rental Mumbai, SUV Cab Jyotirlinga Tour, Sedan Cab Jyotirlinga Trip, Mumbai Jyotirlinga Pilgrimage Cab, 24×7 Jyotirlinga Taxi Mumbai, Family Cab for 5 Jyotirlinga Darshan, Corporate Jyotirlinga Cab Mumbai, Long Trip Cab Mumbai Jyotirlinga, Safe Jyotirlinga Darshan Cab, Premium Jyotirlinga Tour Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/9.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitofivejyotilingacab;